module.exports = __webpack_public_path__ + "static/media/thumb.6ea23087.jpg";